export enum ErrorCode {
    NoError = "NoError",
    ParameterIsRequired = "ParameterIsRequired",
    RequiredParameterIsEmpty = "RequiredParameterIsEmpty",
    CombinationOfParametersIsNotValid = "CombinationOfParametersIsNotValid",
    UnrecoginzedVin = "UnrecoginzedVin",
    ModelNotFound = "ModelNotFound",
    EditionNotFound = "EditionNotFound",
    NoItems = "NoItems"
}